import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  ModalOverlay,
  Modal,
  Card,
  CardBody,
  Title,
  Copy,
  SecondaryButton
} from "app/NativeComponents/common";
import { TextButton } from "app/NativeComponents/snippets";

import {
  setModal,
  toggleModal,
  toggleActionSheet,
  toggleConversationLeadView,
  appRedirect,
  updateConversation,
  updateOwnerInfo
} from "app/NativeActions";

class ConversationMore extends Component {
  renderAssignButton() {
    if (!this.props.toggle_conversation_lead_view) {
      return (
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <SecondaryButton
            onPress={() => {
              this.props.toggleActionSheet(null);

              this.props.toggleConversationLeadView({
                show: true,
                new_property: true
              });
              this.props.appRedirect({
                redirect: "goForward",
                payload: { add: "lead" }
              });
            }}
          >
            Reassign Lead
          </SecondaryButton>
        </Card>
      );
    }
  }

  renderCloseButton() {
    if (this.props.active_conversation[0].closed_conversation != 1) {
      return (
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <SecondaryButton
            onPress={() => {
              this.props.toggleActionSheet(null);
              this.props.updateConversation({
                token: this.props.token,
                type: "close_conversation",
                conversation_id: this.props.active_conversation[0].id,
                onSuccess: () => {}
              });
              /*
              if (this.props.device == "mobile") {
                this.props.appRedirect({
                  redirect: "goBack",
                  payload: {
                    type: "message_engine"
                  }
                });
              }
              */
            }}
          >
            Close Conversation
          </SecondaryButton>
        </Card>
      );
    } else if (this.props.active_conversation[0].closed_conversation == 1) {
      return (
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <SecondaryButton
            onPress={() => {
              this.props.toggleActionSheet(null);
              this.props.updateConversation({
                token: this.props.token,
                type: "open_conversation",
                conversation_id: this.props.active_conversation[0].id,
                onSuccess: () => {}
              });
            }}
          >
            Reopen Conversation
          </SecondaryButton>
        </Card>
      );
    }
  }

  renderMarkAsBadButton() {
    if (
      this.props.active_conversation &&
      this.props.active_conversation.length > 0 &&
      this.props.active_conversation[0].lead_phone_number &&
      this.props.active_conversation[0].property &&
      this.props.active_conversation[0].lead_phone_number.phone_number &&
      this.props.active_conversation[0].lead_phone_number.blocked != 1 &&
      this.props.active_conversation[0].lead_phone_number.do_not_call != 1 &&
      this.props.active_conversation[0].lead_phone_number.bad_phone != 1
    ) {
      return (
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <SecondaryButton
            onPress={() => {
              this.props.updateOwnerInfo({
                token: this.props.token,
                deal_id:
                  this.props.active_conversation[0].property &&
                  this.props.active_conversation[0].property.deal
                    ? this.props.active_conversation[0].property.deal.id
                    : null,
                owner_phone_number_id: this.props.active_conversation[0]
                  .lead_phone_number.owner_phone_number_id,
                type: "edit_phone_number",
                phone_label: this.props.active_conversation[0].lead_phone_number
                  .phone_label,
                phone_number: this.props.active_conversation[0]
                  .lead_phone_number.phone_number,
                bad_phone: 1,
                onSuccess: () => {}
              });
              this.props.toggleActionSheet(null);
            }}
          >
            Mark Number As "Wrong"
          </SecondaryButton>
        </Card>
      );
    }
  }

  renderDoNotCallButton() {
    if (
      this.props.active_conversation &&
      this.props.active_conversation.length > 0 &&
      this.props.active_conversation[0].lead_phone_number &&
      this.props.active_conversation[0].lead_phone_number.phone_number &&
      this.props.active_conversation[0].lead_phone_number.do_not_call != 1
    ) {
      return (
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <SecondaryButton
            onPress={() => {
              this.props.setModal({
                title: 'Report To "Do Not Call" list?',
                description:
                  'Are you sure you want to report add this phone number to the "Do Not Call" list?',
                icon: "",
                submit: "Report Phone Number",
                buttonType: "destroy",
                onPress: () => {
                  this.props.updateOwnerInfo({
                    token: this.props.token,
                    deal_id:
                      this.props.active_conversation[0].property &&
                      this.props.active_conversation[0].property.deal
                        ? this.props.active_conversation[0].property.deal.id
                        : null,
                    owner_phone_number_id: this.props.active_conversation[0]
                      .lead_phone_number.owner_phone_number_id,
                    type: "master_do_not_call_list",
                    phone_number: this.props.active_conversation[0]
                      .lead_phone_number.phone_number,
                    onSuccess: () => {}
                  });
                },
                cancel: "Cancel",
                onCancel: () => {}
              });
              this.props.toggleModal({ show: true, type: "normal" });
              this.props.toggleActionSheet(null);
            }}
          >
            Report To "Do Not Call" List
          </SecondaryButton>
        </Card>
      );
    }
  }

  render() {
    if (
      this.props.actionSheet == "conversation_more" &&
      this.props.active_conversation &&
      this.props.active_conversation.length > 0
    ) {
      return (
        <ModalOverlay
          isVisible={true}
          onPress={() => this.props.toggleActionSheet(null)}
        >
          <Modal actionSheet>
            <Card
              style={{
                minWidth: "95%",
                paddingBottom: this.props.device == "mobile" ? 10 : 0
              }}
            >
              <CardBody>
                <Title style={{ textAlign: "center" }}>More Options</Title>
                <Copy style={{ textAlign: "center" }}>
                  Select one of the following options
                </Copy>
              </CardBody>
              {this.renderMarkAsBadButton()}
              {this.renderDoNotCallButton()}

              {this.renderAssignButton()}
              {this.renderCloseButton()}
              <TextButton
                onPress={() => this.props.toggleActionSheet(null)}
                text={"Cancel"}
              />
            </Card>
          </Modal>
        </ModalOverlay>
      );
    }
    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, route, message }) => {
  const { token, user } = auth;
  const { actionSheet, device } = native;
  const { active_conversation, toggle_conversation_lead_view } = message;
  return {
    token,
    user,
    actionSheet,
    device,
    active_conversation,
    toggle_conversation_lead_view
  };
};

export default connect(mapStateToProps, {
  setModal,
  toggleModal,
  toggleActionSheet,
  toggleConversationLeadView,
  appRedirect,
  updateConversation,
  updateOwnerInfo
})(ConversationMore);
